import React, {Component} from 'react';
const { Link } = require('react-router');
import MultiClamp from 'react-multi-clamp';

import 'sass/wishlistuser.scss';

import {t} from 'l10n';

export default function WishlistItem({item}) {
    return (
        <div className="item">
            <div className="img">
                <a href={item.buy_as_gift_url} className="icon-basket" target="_blank" title={t('Give as a gift')}/>
                <img src={item.thumbnail_url} alt={item.title} title={item.title}/>
            </div>
            <div className="title">
                <MultiClamp
                    clamp="2"
                    title={item.title}
                    className="title-inner"
                    onClick={() => window.open(item.url, '_blank')}
                >{item.title}</MultiClamp>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/wishlist/WishlistItem.js